import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import PendingProductCreated from "../modals/PendingProductCreated";

export default function CreatePendingProduct({ pendingclub, recurring, changeRecurring, changeView, reviewPendingClub }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [interval, setInterval] = useState("month");
  const { user, dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [totalAccess, setTotalAccess] = useState(false);
  const [token, setToken] = useState(0);
  const [productCreatedModal, setProductCreatedModal] = useState(false);
  const [serverError, setServerError] = useState("");
  const navi = useNavigate();
  const [routineClasses, setRoutineClasses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [priceErr, setPriceErr] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");
const formatTime = (timeInt) => {
  const timeStr = timeInt.toString().padStart(4, '0');
  const hours = timeStr.substring(0, 2);
  const minutes = timeStr.substring(2);
  return `${hours}:${minutes}`;
};


  const handlePriceChange = (e) => {
    let inputValue = e.target.value.replace(/[^\d.]/g, "");
    const decimalIndex = inputValue.indexOf(".");
    if (decimalIndex !== -1) {
      inputValue = inputValue.substring(0, decimalIndex + 1) +
        inputValue.substring(decimalIndex + 1).replace(".", "");
      inputValue = inputValue.substring(0, decimalIndex + 3);
    }
    setPrice(inputValue);
  };

  const handleTotalAccessCheckboxChange = (event) => {
    setTotalAccess(event.target.checked);
  };

  const handleCheckboxChange = (classId) => {
    const isSelected = selectedClasses.some((item) => item.eventId === classId);
    if (isSelected) {
      setSelectedClasses(selectedClasses.filter((item) => item.eventId !== classId));
    } else {
      setSelectedClasses([...selectedClasses, { productId: 0, eventId: classId }]);
    }
  };

  const fetchData = async () => {
    try {
      const routineResponse = await axios.get(`${ApiConnectionString}/api/PendingEvents`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (routineResponse.status === 200) {
        setRoutineClasses(routineResponse.data);
      }
    } catch (error) {
      if (error.status === 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
    }
  };

  useEffect(() => {
    let timeout;
    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let error = false;

    const formatString = (input) => {
      if (typeof input === "string" && !input.includes(".")) {
        return input + "00";
      }
      return input;
    };

    const formattedPrice = formatString(price);

    if (parseInt(formattedPrice.toString().replace(".", ""), 10) < 100) {
      setPriceErr("too low");
      error = true;
    }

    if (recurring) {
      switch (interval) {
        case "month":
          if (price > 250) {
            setPriceErr("Monthly subscriptions must not exceed \u00a3250");
            error = true;
          }
          break;
        case "week":
          if (price > 75) {
            setPriceErr("Weekly subscriptions must not exceed \u00a375");
            error = true;
          }
          break;
        case "year":
          if (price > 2500) {
            setPriceErr("Yearly subscriptions must not exceed \u00a32500");
            error = true;
          }
          break;
      }
    } else if (price > 250) {
      setPriceErr("Price must not exceed \u00a3250");
      error = true;
    }

    if (!error) {
      const createProduct = {
        name,
        description,
        recurring,
        price: parseInt(formattedPrice.toString().replace(".", ""), 10),
        pendingClubId: pendingclub.id,
        ...(recurring ? { interval } : { token }),
        accesses: totalAccess ? null : selectedClasses,
        totalAccess,
      };

      try {
        const response = await axios.post(`${ApiConnectionString}/api/PendingProduct`, createProduct, {
          headers: { Authorization: `bearer ${user.token}` },
        });

        if (response.status === 200) {
          reviewPendingClub();
          setProductCreatedModal(true);
        }
      } catch (error) {
        if (error.response?.status === 400) {
          setServerError(error.response.data);
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="container bg-white mt-3 pb-3 rounded shadow">
      <div className="blueBanner d-flex justify-content-between align-items-center">
        <p className="fw-bold p-2 mb-0">Create a Payment Option</p>
        <button onClick={() => changeView("mainPage")} className="saveChanges-button m-2">
          Go Back
        </button>
      </div>

      <form className="p-3" onSubmit={handleSubmit}>
        <h5 className="text-center fw-bold mb-3">
          {recurring ? "Subscription" : "Flexible Class Pack"}
        </h5>

        <div className="mb-3">
          <label className="form-label">Title</label>
          <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
          {nameErr && <p className="text-danger small">{nameErr}</p>}
        </div>

        <div className="mb-3">
          <label className="form-label">Subtitle</label>
          <input className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} required />
          <div className="form-text">Example: "Access to all classes" or "Access to all beginner classes."</div>
        </div>

        <div className="mb-3" style={{ maxWidth: "300px" }}>
          <label className="form-label">Cost</label>
          {/* <input className="form-control" type="text" value={`\u00a3${price}`} onChange={handlePriceChange} required /> */}
          <input
  className="form-control"
  type="text"
  value={`${pendingclub.country === "UK" ? "£" : "$"}${price}`}
  onChange={handlePriceChange}
  required
/>
          {priceErr && <p className="text-danger small">{priceErr}</p>}
        </div>

        {!recurring && (
          <div className="mb-3" style={{ maxWidth: "300px" }}>
            <label className="form-label">Classes</label>
            <input className="form-control" type="number" value={token} onChange={(e) => setToken(e.target.value)} />
            <div className="form-text">e.g. Entering "10" means the user can book into 10 classes.</div>
          </div>
        )}

        {recurring && (
          <div className="mb-3" style={{ maxWidth: "300px" }}>
            <label className="form-label">Select Interval</label>
            <select className="form-select" value={interval} onChange={(e) => setInterval(e.target.value)}>
              <option value="month">Month</option>
              <option value="week">Week</option>
              <option value="year">Year</option>
            </select>
          </div>
        )}

        <div className="mb-3 form-check">
          <input className="form-check-input" type="checkbox" checked={totalAccess} onChange={handleTotalAccessCheckboxChange} />
          <label className="form-check-label">Total Access</label>
        </div>

        {!totalAccess && routineClasses.length > 0 && (
          <div className="mb-3">
            <p><strong>Routine Classes</strong></p>
            <div className="form-text mb-2">Tick classes that are granted access with this payment option.</div>
            {routineClasses.map((cls) => (
              <div className="form-check" key={cls.id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedClasses.some((item) => item.eventId === cls.id)}
                  onChange={() => handleCheckboxChange(cls.id)}
                />
              <label className="form-check-label">
  {cls.name} | {cls.day} | {formatTime(cls.timeIn)} - {formatTime(cls.timeOut)}
</label>
              </div>
            ))}
          </div>
        )}

        {serverError && <p className="text-danger">{serverError}</p>}

        <div className="d-flex justify-content-center">
          <button className="saveChanges-button fw-bold" type="submit">Create</button>
        </div>
      </form>

      <hr />

      <div className="text-center">
        <p>If you'd like to switch to a {recurring ? '"Flexible Class Pack"' : '"Subscription"'} option, press the button below.</p>
        <button className="btn btn-outline-secondary" onClick={() => changeRecurring(!recurring)}>
          Switch To {recurring ? 'Flexible Class Pack' : 'Subscription'}
        </button>
      </div>

      {productCreatedModal && <PendingProductCreated changeView={changeView} />}
    </div>
  );
}
